import React, { useEffect,useState } from "react"
import MainNav from "./Helpers/mainNav"
import styles from './styles.module.css'
import { useMatchMedia } from "../Sections/Hooks/useMatchMedia"

export default function Home({ link, version, iconLink }) {
  // const [isDesktop] = useMatchMedia('(min-width: 769px)', true)



  
  // useEffect(() => {
  //   window.onscroll = function () { scrollFunction() };
  //   function scrollFunction() {
  //     if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
  //       if (document.getElementById("header")) document.getElementById("header").style.position = "fixed";
  //       if (document.getElementById("header")) {
  //         document.getElementById("header").style.top = "0";
  //         document.getElementById("header").style.bottom = null;
  //       }
  //     } else {
  //       if (isDesktop) {
  //         if (document.getElementById("header")) document.getElementById("header").style.position = "unset";
  //       }
  //     }
  //   }
  //   if(document.getElementById("hubspot-messages-iframe-container")) document.getElementById("hubspot-messages-iframe-container").style.top = 'unset';
  // }, [isDesktop])


  
  
    const [isFixed, setIsFixed] = useState(false);
  
    useEffect(() => {
      const navbar = document.getElementById("header");
      const originalTop = navbar?.offsetTop || 0;
  
      const handleScroll = () => {
        if (window.scrollY > originalTop) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      // Jab back button se aaye tab bhi check karo
      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          handleScroll();
        }
      });
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
    return (
      <header
        className={`${styles.header} ${isFixed ? styles.fixed : ""}`}
        id="header"
      >
        <MainNav navMenuLinks={link} version={version} iconLink={iconLink} />
      </header>
    );
  }
  

